interface FilterOption {
  value: string;
  label: string;
}

interface FilterGroupProps {
  label: string;
  options: FilterOption[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterGroup({ label, options, value, onChange }: FilterGroupProps) {
  return (
    <div className="flex flex-col gap-3">
      <span className="text-sm font-medium text-foreground-900 flex items-center gap-2">
        <span className="w-1 h-4 rounded-full bg-accent-500"></span>
        {label}
      </span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const isActive = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onChange(option.value)}
              className={`px-3 py-1.5 rounded-full text-xs md:text-sm whitespace-nowrap transition-colors cursor-pointer ${
                isActive
                  ? "bg-primary-700 text-background-50"
                  : "bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900"
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}